import apiClient from './apiClient';
import cacheService from './cacheService';

const cacheableRequest = (endpoint, maxAgeMinutes = 5, bypassCacheLookup = false) => {
  if (bypassCacheLookup !== true) {
    const cached = cacheService.get(endpoint);
    if (cached) return cached;
  }

  const request = apiClient.get(endpoint).catch(error => {
    // Only evict our own entry. A bypassCacheLookup call replaces it while this
    // request is still in flight, and that newer one may yet succeed.
    if (cacheService.get(endpoint) === request) cacheService.remove(endpoint);
    return Promise.reject(error);
  });

  cacheService.set(endpoint, request, maxAgeMinutes);
  return request;
};

export default cacheableRequest;
